import { render, staticRenderFns } from "./HomeLawMasterDayReport.vue?vue&type=template&id=572e9ce2&scoped=true"
import script from "./HomeLawMasterDayReport.vue?vue&type=script&lang=js"
export * from "./HomeLawMasterDayReport.vue?vue&type=script&lang=js"
import style0 from "./HomeLawMasterDayReport.vue?vue&type=style&index=0&id=572e9ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572e9ce2",
  null
  
)

export default component.exports